import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  nextTick,
  onMounted,
  computed,
  getCurrentInstance,
} from "../../../adapter-vue";
import TUIChatEngine, {
  IConversationModel,
  TUIStore,
  TUITranslateService,
} from "@tencentcloud/chat-uikit-engine";
import { TUIGlobal } from "@tencentcloud/universal-api";
import { CONV_OPERATION } from "../../../constant";
import { isPC, isUniFrameWork } from "../../../utils/env";
import Overlay from "../../common/Overlay/index.vue";
import Dialog from "../../common/Dialog/index.vue";

interface IProps {
  actionsMenuPosition: {
    top: number;
    left?: number;
    conversationHeight?: number;
  };
  selectedConversation: IConversationModel | undefined;
  selectedConversationDomRect: DOMRect | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    actionsMenuPosition: null,
    selectedConversation: null,
    selectedConversationDomRect: null
  },
  emits: ["closeConversationActionMenu"],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  actionsMenuPosition: {
    top: number;
    left?: number;
    conversationHeight?: number;
  };
  selectedConversation: IConversationModel | undefined;
  selectedConversationDomRect: DOMRect | undefined;
}




const thisInstance = getCurrentInstance()?.proxy || getCurrentInstance();
const actionsMenuDomRef = ref<HTMLElement | null>();
const isHiddenActionsMenu = ref(true);
const isShowDeleteConversationDialog = ref<boolean>(false);
const currentConversation = TUIStore.getConversationModel(
  props.selectedConversation?.conversationID || ""
);
const _actionsMenuPosition = ref<{
  top: number;
  left?: number;
  conversationHeight?: number;
}>(props.actionsMenuPosition);

onMounted(() => {
  checkExceedBounds();
});

const deleteConversationDialogTitle = computed(() => {
  return props.selectedConversation?.type === TUIChatEngine.TYPES.CONV_C2C
    ? "TUIConversation.删除后，将清空该聊天的消息记录"
    : props.selectedConversation?.type === TUIChatEngine.TYPES.CONV_GROUP
    ? "TUIConversation.删除后，将清空该群聊的消息记录"
    : "";
});
function checkExceedBounds() {
  // When the component is initially rendered, it executes and self-checks whether the boundary exceeds the screen, and handles it in nextTick.
  nextTick(() => {
    if (isUniFrameWork) {
      // check exceed bounds
      const query = TUIGlobal?.createSelectorQuery().in(thisInstance);
      query
        .select(`#conversation-actions-menu`)
        .boundingClientRect((data) => {
          if (data) {
            // check if actionsMenu is exceed bottom of the screen
            if (data.bottom > TUIGlobal?.getWindowInfo?.().windowHeight) {
              _actionsMenuPosition.value = {
                ...props.actionsMenuPosition,
                top:
                  props.actionsMenuPosition.top -
                  (props.actionsMenuPosition.conversationHeight || 0) -
                  data.height,
              };
            }
            // check if actionsMenu is exceed right of the screen
            if (
              _actionsMenuPosition.value.left + data.width + 5 >
              TUIGlobal.getWindowInfo().windowWidth
            ) {
              _actionsMenuPosition.value.left =
                TUIGlobal.getWindowInfo().windowWidth - data.width - 5;
            }
          }
          isHiddenActionsMenu.value = false;
        })
        .exec();
    } else {
      // Handling the situation where the native Vue menu is lower than the screen
      const rect = actionsMenuDomRef.value?.getBoundingClientRect();
      // The PC side sets the position of actionsMenu according to the position of the mouse click, otherwise the default value of 167px is used
      if (isPC && typeof props.actionsMenuPosition.left !== "undefined") {
        _actionsMenuPosition.value.left = props.actionsMenuPosition.left;
      }
      if (rect && rect.bottom > window.innerHeight) {
        _actionsMenuPosition.value.top =
          props.actionsMenuPosition.top -
          (props.actionsMenuPosition.conversationHeight || 0) -
          rect.height;
      }
      isHiddenActionsMenu.value = false;
    }
  });
}

const handleItem = (params: { name: string }) => {
  const { name } = params;
  const conversationModel = currentConversation;
  if (!name || !conversationModel || !conversationModel.conversationID) {
    return;
  }
  switch (name) {
    case CONV_OPERATION.DELETE:
      conversationModel?.deleteConversation();
      break;
    case CONV_OPERATION.ISPINNED:
      conversationModel?.pinConversation();
      break;
    case CONV_OPERATION.DISPINNED:
      conversationModel?.pinConversation();
      break;
    case CONV_OPERATION.MUTE:
      conversationModel?.muteConversation();
      break;
    case CONV_OPERATION.NOTMUTE:
      conversationModel?.muteConversation();
      break;
  }
  emits("closeConversationActionMenu");
};

const deleteConversation = () => {
  isShowDeleteConversationDialog.value = true;
};

const updateShowDeleteConversationDialog = (isShow: boolean) => {
  if (!isShow) {
    emits("closeConversationActionMenu");
  }
  isShowDeleteConversationDialog.value = isShow;
};

return { __sfc: true,emits, props, thisInstance, actionsMenuDomRef, isHiddenActionsMenu, isShowDeleteConversationDialog, currentConversation, _actionsMenuPosition, deleteConversationDialogTitle, checkExceedBounds, handleItem, deleteConversation, updateShowDeleteConversationDialog, TUITranslateService, CONV_OPERATION, isPC, Overlay, Dialog }
}

})